import { IDI_IMPORT_START_LOADING, IDI_IMPORT_END_LOADING, IDI_IMPORT_LOADED } from "../constants/IdiImportConstants";

const initialState = {
    loading: false,
    fbo: null
};

const IdiImportReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_IMPORT_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_IMPORT_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_IMPORT_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IdiImportReducer;
